import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ba-product-info-prioritized-cell ba-column-title ba-text ba-text-right", {
      'ba-text-lighter': $props.type === 'rev_share' && (_ctx.getRowClass == 'ba-row-paused' || _ctx.getRowClass == 'ba-row-regular')
    }])
  }, [$props.type === 'ads_net_profit' ? (_openBlock(), _createBlock(_component_currency_value, {
    key: 0,
    value: $props.value,
    currency: $props.currency,
    precision: $props.precision,
    allowPrecisionModification: false
  }, null, 8, ["value", "currency", "precision"])) : _createCommentVNode("", true), $props.type === 'rev_share' ? (_openBlock(), _createBlock(_component_percentage_value, {
    key: 1,
    value: $props.value,
    type: "ba_table"
  }, null, 8, ["value"])) : _createCommentVNode("", true)], 2);
}